exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-wrapper[data-v-f33e16b6]{width:100%;padding:25px 25%\n}\n.form-wrapper .form-wrapper-frame[data-v-f33e16b6]{width:100%;padding:25px;margin-bottom:15px\n}\n.form-wrapper .form-wrapper-frame .md-subheading[data-v-f33e16b6]{margin-top:35px\n}\n@media(max-width: 1200px){\n.form-wrapper[data-v-f33e16b6]{padding:10px .5%;margin-left:0\n}\n}\n#submit-btn[data-v-f33e16b6]{margin:25px 0;width:33%;padding:6px;font-size:1.1em\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-f33e16b6","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/Impersonate.vue
// module id = 115
// module chunks = 0